import React from "react";

type DueTimeSelectorProps = {
  dueTimes: string[];
  onChange: (dueTimes: string[]) => void;
};

const TIME_OPTIONS = Array.from({ length: 24 }, (_, h) =>
  ["00", "15", "30", "45"].map(
    (m) => `${h.toString().padStart(2, "0")}:${m}`
  )
).flat();

export const DueTimeSelector: React.FC<DueTimeSelectorProps> = ({
  dueTimes,
  onChange,
}) => {
  const addDueTime = (time: string) => {
    if (!time) return;
    if (dueTimes.includes(time)) return;

    onChange([...dueTimes, time]);
  };

  const removeDueTime = (time: string) => {
    onChange(dueTimes.filter((t) => t !== time));
  };

  return (
    <div className="space-y-4">

      {/* Label */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Add due time
        </label>

        {/* Instant-add selector */}
        <select
          defaultValue=""
          onChange={(e) => {
            addDueTime(e.target.value);

            // reset select back to placeholder
            e.target.value = "";
          }}
          className="
            border border-gray-300 rounded-md px-3 py-2 text-sm
            focus:outline-none focus:ring-2 focus:ring-blue-500
          "
        >
          <option value="">Select time</option>

          {TIME_OPTIONS.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </div>

      {/* Current due times */}
      <div>
        {dueTimes.length === 0 ? (
          <p className="text-sm text-gray-500 italic">
            No due times set
          </p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {dueTimes.map((t) => (
              <span
                key={t}
                className="
                  flex items-center gap-1
                  bg-gray-100 border border-gray-300
                  rounded-full px-3 py-1 text-sm
                "
              >
                {t}

                <button
                  type="button"
                  onClick={() => removeDueTime(t)}
                  className="
                    text-gray-500 hover:text-red-600 font-medium
                  "
                  aria-label={`Remove ${t}`}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
      </div>

    </div>
  );
};